import { get } from "../../service/api";

const EmailOTPValidation = async (register) => {
  try {
    const response = await get(`/merchant/emailValidation?email=${register}`);
    return response.otp;
  } catch (error) {
    console.error("Error EmailOTPValidation:", error);
    throw error;
  }
};

export default EmailOTPValidation;
